"use strict";

define('controller/letter.template/detail',['require','exports','module','underscore','marionette','../base','langs','uikit/uikit','view/text.editor','model/document','model/letter.template','model/template.type','model/letter.tag','libs/route.helper','libs/loader.helper','appkit/changes.helper','config','templates','evisions/redactor.plugins/macro.redactor.plugin','evisions/redactor.plugins/disabled.redactor.plugin'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var RegionController = require('../base');
  var langs = require('langs');
  var UIKit = require('uikit/uikit');
  var TextEditor = require('view/text.editor');
  var Document = require('model/document');
  var LetterTemplate = require('model/letter.template');
  var TemplateType = require('model/template.type');
  var LetterTag = require('model/letter.tag');
  var RouteHelper = require('libs/route.helper');
  var LoaderHelper = require('libs/loader.helper');
  var ChangesHelper = require('appkit/changes.helper');
  var config = require('config');
  var Templates = require('templates');
  require('evisions/redactor.plugins/macro.redactor.plugin');
  require('evisions/redactor.plugins/disabled.redactor.plugin');
  function generateLetterDetailLink(model) {
    return RouteHelper.createLink(model.isNew() ? 'letterTemplate:create' : 'letterTemplate:detail', model, {
      letterTemplateId: 'id'
    });
  }
  ;
  function navigateLetterDetail(model) {
    app.navigate(generateLetterDetailLink(model).slice(1), {
      trigger: true
    });
  }
  ;
  var RootView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: Templates.IRB['letter.template.detail'],
    useInjector: true,
    options: {
      pageTitle: langs.phrase('LetterTemplateDetail.Title')
    }
  });
  var LetterTemplateDetailController = RegionController.extend({
    header: langs.phrase('App.Title'),
    authorities: ['PERM_VIEW_LETTERTEMPLATE'],
    onStart: function onStart() {
      var app = this.app,
        region = this.region,
        state = this.state;
      var root = new RootView(),
        letterTemplateModel = new LetterTemplate({
          id: state.get('letterTemplateId')
        }),
        templateTypes = TemplateType.all(Document.SUBMISSION),
        loaderHelper = new LoaderHelper([letterTemplateModel, templateTypes]),
        changesHelper = new ChangesHelper().add(letterTemplateModel),
        tags = LetterTag.all(),
        form = root.form,
        breadcrumb = root.breadcrumb;
      changesHelper.listenTo(root, 'destroy', changesHelper.off);
      root.$el.css(config.contentCss);
      form.model = letterTemplateModel;
      breadcrumb.collection = new Backbone.Collection([{
        text: langs.phrase('LetterTemplatesList.Title'),
        link: '#letter/template/list'
      }, {
        text: app.title
      }]);
      var options = _.extend({}, config.redactorDefaults, {
        name: 'text',
        plugins: ['macro', 'disabled'],
        macros: tags
      });
      form.addGroup({
        autoSize: false
      }).addField({
        width: 7,
        text: langs.phrase('LetterTemplateDetail.Label.Name'),
        required: true
      }, new UIKit.Input({
        name: 'title'
      })).getOption('parent').addField({
        width: 6,
        text: langs.phrase('LetterTemplateDetail.Label.SubmissionType'),
        required: true
      }, new UIKit.Dropdown({
        name: 'templateType',
        search: true
      })).getOption('parent').addField({
        width: 3,
        text: 'Active'
      }, new UIKit.Checkbox({
        name: 'active',
        toggle: true,
        polar: true
      })).getOption('parent').getOption('parent').addGroup().addField({
        width: 16
      }, new TextEditor(options));
      form.templateType.collection = templateTypes;
      form.templateType.childBindings.text = 'description';
      form.bindings.title = 'name';
      form.bindings.active = 'active';
      form.bindings.text = 'content';
      form.bindings.templateType = 'templateType';
      root.save.icon = 'save';
      root.save.text = langs.phrase('LetterTemplateDetail.SaveButton');
      root.save.model = new LoaderHelper([letterTemplateModel], {
        delay: 0
      });
      root.save.bindings.loading = 'loading';
      root.save.disabled = true;
      root["delete"].disabled = true;
      root["delete"].text = langs.phrase('LetterTemplateDetail.DeleteButton');
      var unsavedModalEvents = app.request('modal', {
        type: 'UNSAVED_CHANGES',
        state: changesHelper
      }, {
        ariaControlsId: 'letterDetails'
      });
      root.on('save:press', function () {
        letterTemplateModel.save();
      }).on('delete:press', function () {
        app.request('modal', {
          type: 'CONFIRM_DESTROY',
          state: state,
          name: form.model.get('name'),
          entity: 'Letter Template'
        }, {
          ariaControlsId: 'letterDetails'
        }).on('confirm', function () {
          letterTemplateModel.destroy({
            wait: true
          });
        });
      }).listenTo(unsavedModalEvents, 'save:model', function () {
        letterTemplateModel.save();
      }).listenTo(changesHelper, 'change:' + ChangesHelper.UNSAVED_CHANGES, function () {
        root.save.disabled = !changesHelper.get(ChangesHelper.UNSAVED_CHANGES);
      }).listenTo(loaderHelper, 'change:loading', function () {
        if (root._pageLoaded) {
          form.state = loaderHelper.get('loading') ? 'loading' : '';
        }
      }).listenTo(letterTemplateModel, 'change:templateType', function () {
        tags.params({
          templateType: letterTemplateModel.get('templateType').get('description')
        }).fetch();
      }).listenTo(templateTypes, 'sync', function () {
        if (letterTemplateModel.isNew() && !letterTemplateModel.has('letterTemplate')) {
          letterTemplateModel.set('templateType', templateTypes.at(0));
          changesHelper.reset();
        }
      }).listenTo(letterTemplateModel, 'destroy', function () {
        app.navigate(RouteHelper.resolve('letterTemplate:list').slice(1), {
          trigger: true
        });
      }).listenTo(letterTemplateModel, 'sync', function () {
        root["delete"].disabled = false;
      }).on('before:destroy', function () {
        changesHelper.off().stopListening();
        loaderHelper.off().stopListening();
      });
      if (letterTemplateModel.isNew()) {
        root.listenTo(letterTemplateModel, 'sync', function () {
          state.changeRouteName('letterTemplate:detail').set({
            letterTemplateId: letterTemplateModel.id
          });
        }).listenTo(form.title, 'show', _.debounce(function () {
          form.title.focus();
        }, 200));
        region.show(root);
      } else {
        letterTemplateModel.fetch();
      }
      state.addPageDependencies([letterTemplateModel, templateTypes, tags]).on('page:loaded', function () {
        root._pageLoaded = true;
        templateTypes.set(letterTemplateModel.get('templateType'), {
          remove: false,
          replace: true
        });
        region.show(root);
      }).on('page:error', function () {
        app.navigate(RouteHelper.resolve('letterTemplate:list').slice(1), {
          trigger: true
        });
        root.destroy();
      }).on('page:cancel', function () {
        root.destroy();
      });
      templateTypes.fetch();
    }
  });
  module.exports = LetterTemplateDetailController;
});

